var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0857 33C27.0857 33.7425 27.6861 34.3429 28.4286 34.3429C29.171 34.3429 29.7714 33.7425 29.7714 33V20.4286C29.7714 19.6861 29.171 19.0857 28.4286 19.0857C27.6861 19.0857 27.0857 19.6861 27.0857 20.4286V33ZM20.2286 33C20.2286 33.7425 20.829 34.3429 21.5714 34.3429C22.3139 34.3429 22.9143 33.7425 22.9143 33V20.4286C22.9143 19.6861 22.3139 19.0857 21.5714 19.0857C20.829 19.0857 20.2286 19.6861 20.2286 20.4286V33ZM39.8571 14.5143H34.3429V12.4286C34.3429 10.4293 32.7291 8.8 30.7406 8.8H19.2857C17.285 8.8 15.6571 10.4278 15.6571 12.4286V14.5143H10.1429C9.4004 14.5143 8.8 15.1147 8.8 15.8571C8.8 16.5996 9.4004 17.2 10.1429 17.2H39.8571C40.5996 17.2 41.2 16.5996 41.2 15.8571C41.2 15.1147 40.5996 14.5143 39.8571 14.5143ZM18.3429 12.4286C18.3429 11.9093 18.7665 11.4857 19.2857 11.4857H30.7406C31.2521 11.4857 31.6571 11.8935 31.6571 12.4286V14.5143H18.3429V12.4286Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0023 41.2H33.0046C35.0053 41.2 36.6332 39.5722 36.6332 37.5714V20.4583C36.6332 19.7171 36.0329 19.1154 35.2903 19.1154C34.5477 19.1154 33.9474 19.7171 33.9474 20.4583V37.5714C33.9474 38.0918 33.525 38.5143 33.0046 38.5143H17.0023C16.4829 38.5143 16.0594 38.0917 16.0594 37.5714V20.4114C16.0594 19.6701 15.4579 19.0686 14.7166 19.0686C13.9753 19.0686 13.3737 19.6701 13.3737 20.4114V37.5714C13.3737 39.5722 15.0016 41.2 17.0023 41.2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.0566974b08f22f9b71fa36e27d96c8ca.svg";
export { ForwardRef as ReactComponent };